/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { endTime, airdropStartTime } from "../config";
import { isDateBetween, isDateAfter } from "@/shares/utils/date";
import { addThousandSeparator } from "@/shares/utils/format";
import { formatAddress } from "@/utils/common";
import { useBitKeepDetection } from "@/hooks/useBitKeepDetection";
import { useBitKeepContext } from "@/components/BitKeepProvider";
import success from "@/assets/images/success.svg";
import unqualified from "../assets/unqualified.png";
import calculating from "../assets/calculating.png";
const walletInfoInit = {
    headPic: "",
    walletAddress: {},
    walletAvatarUrl: "",
    walletId: "",
    walletName: "wallet Name",
    walletType: ""
};
export default function SubmitFeedback(param) {
    let { airdropRes } = param;
    var _walletInfo_walletAddress, _walletInfo_walletAddress1;
    const translationPageKey = "Tomarket_activity";
    const t = useTranslations("");
    const isBitkeep = useBitKeepDetection();
    const { bitkeep, isReady, error } = useBitKeepContext();
    const [walletInfo, setWalletInfo] = useState(walletInfoInit);
    useEffect(()=>{
        if (isReady && bitkeep && isBitkeep) {
            const init = async ()=>{
                try {
                    bitkeep.setTitle(t("swapToken", {
                        coin1: "BWB",
                        coin2: "BGB"
                    }));
                    const { success, data } = await bitkeep.getWalletInfo();
                    if (success) {
                        setWalletInfo({
                            ...data
                        });
                    }
                } catch (err) {
                    console.error("BitKeep Error:", err);
                }
            };
            init();
        }
    }, [
        isReady,
        isBitkeep,
        bitkeep,
        error
    ]);
    var _walletInfo_walletAddress_apt;
    // const triedAddress = useMemo(() => {
    //   let address = '';
    //   if (typeof window !== 'undefined') {
    //     address =
    //       (window as any)?.__bitkeepAccount?.apt || window.localStorage.getItem('toma-apt-address');
    //   }
    //   return address;
    // }, []);
    console.log("walletInfo===", walletInfo, formatAddress((_walletInfo_walletAddress_apt = walletInfo === null || walletInfo === void 0 ? void 0 : (_walletInfo_walletAddress = walletInfo.walletAddress) === null || _walletInfo_walletAddress === void 0 ? void 0 : _walletInfo_walletAddress.apt) !== null && _walletInfo_walletAddress_apt !== void 0 ? _walletInfo_walletAddress_apt : ""));
    var _walletInfo_walletAddress_apt1;
    return isDateAfter(endTime) ? airdropRes === null ? null : (airdropRes === null || airdropRes === void 0 ? void 0 : airdropRes.participate) ? // 空投结果
    isDateBetween(endTime, airdropStartTime) ? // 计算中
    /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: calculating.src,
                alt: "",
                className: "w-[160px] h-[160px] mb-[12px]"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[18px] font-600 leading-[26px] text-center text-[#0D0E0E]",
                children: t("".concat(translationPageKey, "_calculating"))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[14px] leading-[22px]text-center text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_calculate_tips2"))
            })
        ]
    }) : (airdropRes === null || airdropRes === void 0 ? void 0 : airdropRes.sybil) ? // 合规，显示空投结果
    /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: success.src,
                alt: "",
                className: "w-[160px] h-[160px] mb-[12px]"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[12px] text-[32px] font-700 leading-[32px] text-center text-[#FF3F6D]",
                children: addThousandSeparator((airdropRes === null || airdropRes === void 0 ? void 0 : airdropRes.shouldAirdrop) || 0)
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[24px] font-700 leading-[24px] text-center text-[#FF3F6D]",
                children: "TOMA"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[14px] leading-[22px] text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_reward"))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full justify-between items-center mt-[12px] bg-[#F8F8F9] rounded-[8px] p-[12px]",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-[14px] leading-[22px] text-[#515656]",
                        children: t("".concat(translationPageKey, "_reward_address"))
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col items-end",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: (walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.walletAvatarUrl) || "data:image/png;base64,".concat(walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.headPic),
                                        alt: "",
                                        className: "w-[20px] h-[20px] mr-[8px] rounded-[50%] shrink-0"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-[14px] leading-[22px] font-600 text-[#0D0E0E]",
                                        children: walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.walletName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-[14px] leading-[22px] text-[#515656]",
                                children: formatAddress((_walletInfo_walletAddress_apt1 = walletInfo === null || walletInfo === void 0 ? void 0 : (_walletInfo_walletAddress1 = walletInfo.walletAddress) === null || _walletInfo_walletAddress1 === void 0 ? void 0 : _walletInfo_walletAddress1.apt) !== null && _walletInfo_walletAddress_apt1 !== void 0 ? _walletInfo_walletAddress_apt1 : "")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[12px] text-[14px] leading-[22px]text-center text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_start_time"))
            })
        ]
    }) : // 不合规
    /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: unqualified.src,
                alt: "",
                className: "w-[160px] h-[160px] mb-[12px]"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[12px] text-[18px] leading-[26px] text-[#0D0E0E] font-600 text-center",
                children: t("".concat(translationPageKey, "_unqualified"))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[14px] leading-[22px] text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_unqualified_tips"))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "px-[12px] py-[8px] mt-[12px] text-[13px] font-500 leading-[18px] text-[#FF3F6D] border-2 border-solid border-[rgba(254,91,121,0.10)] rounded-[999px]",
                children: /*#__PURE__*/ _jsx("a", {
                    href: "https://t.me/Tomarket_ai_bot/app",
                    children: t("".concat(translationPageKey, "_back_tomarket"))
                })
            })
        ]
    }) : // 未参与
    /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: unqualified.src,
                alt: "",
                className: "w-[160px] h-[160px] mb-[12px]"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[12px] text-[18px] leading-[26px] text-[#0D0E0E] font-600 text-center",
                children: t("".concat(translationPageKey, "_ended"))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[14px] leading-[22px] text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_ended_tips"))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "px-[12px] py-[8px] mt-[12px] text-[13px] font-500 leading-[18px] text-[#FF3F6D] border-2 border-solid border-[rgba(254,91,121,0.10)] rounded-[999px]",
                children: /*#__PURE__*/ _jsx("a", {
                    href: "https://t.me/Tomarket_ai_bot/app",
                    children: t("".concat(translationPageKey, "_back_tomarket"))
                })
            })
        ]
    }) : // 参与成功
    /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: success.src,
                alt: "",
                className: "w-[160px] h-[160px] mb-[12px]"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[18px] font-600 leading-[26px] text-center text-[#0D0E0E]",
                children: t("".concat(translationPageKey, "_wallet_accepted"))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[4px] text-[14px] leading-[22px]text-center text-[#515656] text-center",
                children: t("".concat(translationPageKey, "_check_back"))
            })
        ]
    });
}
